import * as React from 'react';
import { TNavigationPanel } from './NavigationPanel.types';
import { ADMIN_PANEL_CONFIG } from 'screens/AdminPanel/config';
import { Button } from 'components';
import { ExpandMore } from '@mui/icons-material';
import './NavigationPanel.styles.scss';
import { hasSelectedChild } from './utils';
import { NativeAccordion } from 'components/atoms/NativeAccordion/NativeAccordion';
import { NativeAccordionSelectable } from 'components/atoms/NativeAccordion/NativeAccordionSelectable';

export const NavigationPanel: TNavigationPanel = ({
  selectedPanelItemId,
  setSelectedPanelItem,
}) => {
  const STOCK_ITEM_ID = 'stock-items';
  const stockConfig = ADMIN_PANEL_CONFIG.find((item) => item.id === 'stock');
  const accordionConfigs = ADMIN_PANEL_CONFIG.filter(
    (item) => item.id !== 'stock'
  );

  return (
    <>
      {stockConfig && (
        <Button
          variant={
            selectedPanelItemId === STOCK_ITEM_ID ? 'contained' : 'outlined'
          }
          onClick={() => setSelectedPanelItem(STOCK_ITEM_ID)}
          fullWidth
        >
          {stockConfig.displayName}
        </Button>
      )}

      {accordionConfigs.map((adminPanelConfigItem) => (
        <div key={adminPanelConfigItem.id}>
          <NativeAccordion
            title={adminPanelConfigItem.displayName}
            key={adminPanelConfigItem.id}
          >
            {adminPanelConfigItem.children.map((panelConfigChild) => (
              <NativeAccordionSelectable
                key={panelConfigChild.id}
                title={adminPanelConfigItem.displayName}
                onClick={() => setSelectedPanelItem(panelConfigChild.id)}
                selected={selectedPanelItemId === panelConfigChild.id}
              />
            ))}
          </NativeAccordion>
        </div>
      ))}
    </>
  );
};
